// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jp-0";